import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_UNMATCHED_TRANSACTIONS';

export async function getUnmatchedTransactions(userData: Record<string, string>) {
    try {
        const response = await axios.get(

            `${URL}/pennylane/transactions/unmatched-count/`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userData.userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de la récuperation d\'une production',
            error: error
        });
    }
}
